// extracted by mini-css-extract-plugin
export default {"root":"FormModal_root__s+XV2","noTouch":"FormModal_noTouch__-NF77"};